export default __webpack_public_path__ + "static/media/settings-icon.fbf35334.svg";